import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
    selector: 'app-title-block-warning',
    templateUrl: 'title-block-warning.component.html',
    styleUrls: ['./title-block-warning.component.scss']
  })
  export class TitleBlockWarningComponent {
      constructor(private dialogRef: MatDialogRef<TitleBlockWarningComponent>) {}

      OK() {
          this.close(true);
      }

      Cancel() {
          this.close(false);
      }
      
      async close(value) {
        this.dialogRef.close(value);
      }
  }


// WEBPACK FOOTER //
// ./src/app/services/proTools/ng-components/title-block-warning/title-block-warning.component..ts